import { BrowserRouter, history } from './router/BrowserRouter';
import { PrivateRoute } from './router/PrivateRoute';
import { Routes, Route } from 'react-router-dom';
import SignInPage from './pages/SignIn';
import SignUpPage from './pages/SignUp';
import Dashboard from "./pages/Workspace/Dashboard";
import Settings from './pages/Workspace/Settings';
import Legal from './pages/Workspace/Legal';
import NotFoundPage from './pages/NotFound';
import Welcome from './pages/Welcome';
import ForgetPassword from './pages/ForgetPassword';
import MultipleChoice from './pages/Examination/MultipleChoice';
import { useBootstrap } from './hooks/useBootstarp';
import Toast from './components/Toast';
import { useSelector } from './store/store';
import { selectNotification } from './store/general/selectors';
import { ProtectedRoute } from './router/ProtectedRoute';
import Workspace from './pages/Workspace';
import Jobs from './pages/Workspace/Jobs';
import JobList from './pages/Workspace/Jobs/containers/JobList';
import JobDetail from './pages/Workspace/Jobs/containers/JobDetail';
import CodingExam from './pages/Examination/Coding';
import JobDescription from './pages/JobDescription';
import Support from './pages/Workspace/Support';
import Examination from './pages/Examination';
import Account from './pages/Workspace/Account';
import RecruitingInterview from './pages/Examination/RecruitingInterview';

function App() {
  useBootstrap();
  const notifications = useSelector(selectNotification);

  return (
    <BrowserRouter history={history}>
      <Routes>

        <Route path='/' element={<ProtectedRoute />} >
          <Route path='' element={<Welcome />} />
          <Route path='/signup' element={<SignUpPage />} />
          <Route path='/signin' element={<SignInPage />} />
          <Route path='/forgetpassword' element={<ForgetPassword />} />
        </Route>

        {/* <Route path='/' element={<ProtectedRoute />} >
          <Route path='/supplementary-signup' element={<SupplementarySignUp />} />
        </Route> */}

        <Route path='/job' element={<JobDescription />} />

        <Route path='/workspace' element={<PrivateRoute />} >
          <Route path='' element={<Workspace />} >
            <Route path='' element={<Dashboard />} />
            <Route path='account' element={<Account />} />
            <Route path='legal' element={<Legal />} />
            <Route path='support' element={<Support />} />
            <Route path='exams' element={<Jobs />} >
              <Route path='' element={<JobList />} />
              <Route path=':jobId' element={<JobDetail />} />
            </Route>
            <Route path='settings' element={<Settings />} />
          </Route>
        </Route>

        <Route path="/examination" element={<PrivateRoute />} >
          <Route path='' element={<Examination />} >
            <Route path='multipleChoice' element={<MultipleChoice />} />
            <Route path='coding' element={<CodingExam />} />
            <Route path='interview' element={<RecruitingInterview />} />
          </Route>
        </Route>

        <Route path='*' element={<NotFoundPage />} />

      </Routes>
      <Toast
        autoDelete
        dismissTime={3000}
        toastList={notifications}
      />
    </BrowserRouter>
  );
}

export default App;
